module.exports = __webpack_public_path__ + "media/3.b00927d8.mp3";